<a class="nav-link flex-fill text-center px-0" [routerLink]="item().routerLink"
   [ngClass]="urlPath().startsWith(item().routerLink) ? 'active' : ''">
  {{ item().text }}
</a>
